// extracted by mini-css-extract-plugin
export default {"aboutArea":"AboutTitle_aboutArea__TRMYx","title":"AboutTitle_title__uqOxe","border":"AboutTitle_border__-XULN","details":"AboutTitle_details__SrRNW"};